import React from "react";
import { CheckCircle2, Clock, Euro, Award, Users } from "lucide-react";
import { whyChooseUs, stats, images } from "../mock";

const iconMap = { Clock, Euro, Award, Users };

const WhyChooseUs = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-[1280px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="grid grid-cols-2 gap-4">
              <img
                src={images.laptopRepair}
                alt="Laptop reparatie"
                loading="lazy" className="w-full h-64 object-cover rounded"
              />
              <img
                src={images.workstation}
                alt="Workstation"
                loading="lazy" className="w-full h-64 object-cover rounded mt-10"
              />
              <img
                src={images.circuitBoard}
                alt="Circuit board"
                loading="lazy" className="w-full h-64 object-cover rounded"
              />
              <img
                src={images.motherboard}
                alt="Motherboard"
                loading="lazy" className="w-full h-64 object-cover rounded mt-10"
              />
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <p className="text-sm tracking-[0.3em] uppercase text-neutral-500 mb-3">
              — Waarom Computheer
            </p>
            <h2 className="text-4xl md:text-5xl font-bold text-neutral-900 mb-6 leading-tight">
              Uw IT-partner,
              <br />
              <span className="italic font-light">die het verschil maakt.</span>
            </h2>
            <p className="text-lg text-neutral-600 leading-relaxed mb-10">
              Bij Computheer draait alles om vertrouwen. Wij luisteren naar uw wensen en zorgen
              voor een oplossing die écht werkt — zonder verborgen kosten of technisch jargon.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10">
              {whyChooseUs.map((item, idx) => {
                const Icon = iconMap[item.icon];
                return (
                  <div key={idx} className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-neutral-900 text-white flex items-center justify-center flex-shrink-0">
                      <Icon size={18} />
                    </div>
                    <div>
                      <h4 className="font-semibold text-neutral-900 mb-1">{item.title}</h4>
                      <p className="text-sm text-neutral-600 leading-relaxed">{item.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 border-t border-neutral-200 pt-8">
              {stats.map((s, i) => (
                <div key={i}>
                  <p className="text-3xl md:text-4xl font-bold text-neutral-900 mb-1">{s.value}</p>
                  <p className="text-xs uppercase tracking-wider text-neutral-500">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
